import React from 'react';
import PropTypes from 'prop-types';

import Definition from './Definition';
import { HorseLink } from './links/ProfileLink';

const HorseDefinition = ({
    horseName,
    horseUid,
    countryOriginCode,
    avgFlatWinDist,
    term,
}) => (
    horseUid ? (
        <Definition term={term}>
            <HorseLink
                horseStyleName={horseName}
                horseUid={horseUid}
                className="hp-horseDefinition__link"
            />&nbsp;
            <span className="hp-horseDefinition__country">
                ({countryOriginCode})
            </span>
            {!!avgFlatWinDist && ` (${avgFlatWinDist}f)`}
        </Definition>
    ) : null
);

HorseDefinition.propTypes = {
    avgFlatWinDist: PropTypes.number,
    countryOriginCode: PropTypes.string,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    term: PropTypes.string,
};

export default HorseDefinition;



// WEBPACK FOOTER //
// ./src/js/shared/HorseDefinition.jsx